export default __webpack_public_path__ + "static/media/category_cap.586260ff.webp";